export default function getAuthenticationUrl(): string {
    //TODO: pull url from settings. Creating method to encapsulate this for the future.
    const SSO_INSTANCE_PROD: string = 'https://login.microsoftonline.com/';
    return SSO_INSTANCE_PROD;
}
